import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";
/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// recuperation de tous les etudiants
export const getAllStudents = async (context, params = {}) => {
  const response = await axios.get(apiPaths.baseUrl + `/api/student/all`, {
    params,
    headers: setHeaders(context),
  });
  return response.data;
};

// recuperation des etudiants par classe
export const getAllStudentByClass = async (id_class, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/student/all/${id_class}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// recuperation des etudiants par annee
export const getAllStudentByYear = async (id_academicYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/student/getAllStudentByYear/${id_academicYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// recuperation d'un etudiant via son id
export const getStudentById = async (id_student, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/student/getStudent/${id_student}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// inscrire un nouvel etudiant
export const registerStudent = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/student/register`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// re-inscrire un nouvel etudiant
export const reRegistrationStudent = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/student/reinscription`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// modifier un nouvel etudiant
export const updateStudent = async (id, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/student/updateStudent/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// supprimer un nouvel etudiant
export const deleteStudent = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/student/deleteStudent/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// recuperation de l'inscription d'un etudiant via sa classe
export const getStudentRegistrationByClass = async (id_class, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/student/all/${id_class}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// supprimer l'inscription d'un etudiant
export const deteleStudentRegistration = async (
  id_academicYear,
  id_studentProfil,
  context,
) => {
  const response = await axios.delete(
    apiPaths.baseUrl +
      `/api/student/deleteRegistration/${id_academicYear}/${id_studentProfil}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateStudentRegistration = async (
  id_registration,
  payload,
  context,
) => {
  // Liste des champs autorisés à être modifiés
      // const allowedFields = ['id_class','statut', 'id_parcoursStudent'];
  const response = await axios.put(
    apiPaths.baseUrl + `/api/student/updateRegistration/${id_registration}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// --------------------------Import/Export-------------------------------------------------------

// import des etudiant via annee academique
export const importStudentProfil = async (payload, idYear, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/importStudent/${idYear}`,
    payload,
    {
      headers: {
        ...setHeaders(context),
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

// export des etudiant via annee academique
export const exportStudentProfilByYear = async (id_academicYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/exporte/students/${id_academicYear}`,
    { headers: setHeaders(context), responseType: "blob" },
  );
  return response.data;
};

// export des etudiants via annee academique et classe
export const exportStudentProfilByYearAndClass = async (
  id_academicYear,
  classId,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/exporte/students/${id_academicYear}/${classId}`,
    {
      headers: setHeaders(context),

      responseType: "blob",
    },
  );
  return response.data;
};

// recuperation du template d'import des etudiants
export const templateStudentProfil = async (context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/download/templateStudent`,
    {
      headers: setHeaders(context),

      responseType: "blob",
    },
  );
  return response.data;
};

// Phase 2 ******************
// récupère les abscences d'un étudiant par année scolaire / classe (une classe correspond à une année )
export const getStudentAbsenceByYear = async (
  id_class,
  id_studentPofil,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/absenceStudent/student/${id_class}/${id_studentPofil}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// créer un justificatif
export const createJustificatif = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/justification/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// modifier un justificatif
export const updateJustificatif = async (id_justificatif, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/justification/update/${id_justificatif}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// supprimer un justificatif
export const deleteJustificatif = async (id_justificatif, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/justification/delete/${id_justificatif}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer un justificatif à travers son Id
export const getJustificatifById = async (id_justificatif, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/justification/${id_justificatif}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// Modifier une absence
export const updateAbsence = async (id_absence, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/absenceStudent/update/${id_absence}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// ------------------Génération Absence PDF-------------------------------------

// Générer un PDF d'absence annuel
export const generateAbsencePdfByYear = async (
  id_studentPofil,
  id_academicYear,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/pdf/generate-absenceStudent-annuel-report/${id_studentPofil}/${id_academicYear}`,
    {
      headers: setHeaders(context),
      responseType: "blob",
    },
  );
  return response.data;
};
// Générer un PDF d'absence semstriel
export const generateAbsencePdfBySemester = async (
  id_studentPofil,
  id_academicYear,
  id_evaluationPerid,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/pdf/generate-absenceStudent-periode-report/${id_studentPofil}/${id_academicYear}/${id_evaluationPerid}`,
    {
      headers: setHeaders(context),
      responseType: "blob",
    },
  );
  return response.data;
};

// -----------------------------------------------Sanctions---------------------------------------------------------

// créer une sanction
export const createSanction = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/sanction/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// modifier une sanction
export const updateSanction = async (id_sanction, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/sanction/update/${id_sanction}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer une sanction
export const getSanctionByID = async (id_sanction, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/sanction/${id_sanction}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer les sanctions d'un étudiant
export const getSanctionByStudent = async (id_studentProfil, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/sanction/student-sanction/${id_studentProfil}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// supprimer une sanction
export const deleteSanction = async (id_sanction, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/sanction/delete/${id_sanction}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// creer une absence
export const createAbsence = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/absenceStudent/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// supprimer une absence
export const deleteAbsence = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl +
      `/api/absenceStudent/delete/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// recuperer ules absences par classe
export const getAbsenceByClass = async (
  id_class,
  id_courseVersionEDT,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/absenceStudent/classAbsence/${id_class}/${id_courseVersionEDT}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};
